import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";


export default function WarehouseCreate() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const language = useUserLanguage();
const { translations } = useTranslations(language);
const getText = (key, def) => translations[key] || def;


  const handleSubmit = async (e) => {
    e.preventDefault();

    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/warehouses`, {
      title,
      status: "active",
    });

    toast.success(getText("WAREHOUSE_CREATED_SUCCESS"));
    navigate("/warehouses/table");
  };

  return (
    <div className="container card p-4 mt-3">
      <form onSubmit={handleSubmit}>
        <label className="form-label fw-bold">{getText("WAREHOUSE_NAME_LABEL")}</label>
        <input
          className="form-control mb-3"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <div className="d-flex justify-content-center">
          <button type="submit" className="btn btn-primary">
            {getText("SAVE")}
          </button>
        </div>
      </form>
    </div>
  );
}
